import React from 'react'
import cn from 'classnames'
import Button from './button'

import styles from './navigation-button.module.css'
import Helper from './Helper';


function NavigationButton({ href, selected, children, className,...props }) {
  const { getButtonStyle } = Helper();
  const buttonStyle = () => {
    if(selected) {
      return getButtonStyle();
    } else {
      return {
        backgroundImage: `none`,
        color: `black`
      };
    }
  };

  return (
    <Button
      className={cn(styles.navButton, className)}
      href={href}
      {...props}
      style= {buttonStyle()}>
      {children}
    </Button>
  )
}

export default NavigationButton
